import { defineMessages } from 'react-intl';

export default defineMessages({
  folderNumber: {
    id: 'amc_details.my_refunds.folder_number',
  },
  status: {
    id: 'amc_details.my_refunds.status',
  },
  refundAmount: {
    id: 'amc_details.my_refunds.refund_amount',
  },
  reasonReject: {
    id: 'amc_details.my_refunds.reason_reject',
  },
  costs: {
    id: 'amc_details.my_refunds.costs',
  },
  totalCosts: {
    id: 'amc_details.my_refunds.all.costs',
  },
  Beneficiary: {
    id: 'amc_details.my_refunds.beneficiary.treated',
  },
  aucunContenu: {
    id: 'amc_details.my_refunds.aucun_contenu',
  },
  lossDate: {
    id: 'amc_details.my_refunds.loss_date',
  },
  regulationDate: {
    id: 'amc_details.my_refunds.regulation_date',
  },
  claimNumber: {
    id: 'amc_details.my_refunds.claim_number',
  },
  regulationMode: {
    id: 'amc_details.my_refunds.regulation_mode',
  },
  rib: {
    id: 'amc_details.my_refunds.rib',
  },
  adressMandat: {
    id: 'amc_details.my_refunds.address',
  },
  statusAgrement: {
    id: 'amc_details.my_refunds.status_agrement',
  },
  statusReturn: {
    id: 'amc_details.my_refunds.status_return',
  },
  statusVisite: {
    id: 'amc_details.my_refunds.status_visite',
  },
  statusRejected: {
    id: 'amc_details.my_refunds.status_rejected',
  },
  statusPaid: {
    id: 'amc_details.my_refunds.status_paid',
  },
  statusPecCanceled: {
    id: 'amc_details.my_refunds.status_pec_canceled',
  },
  statusPending: {
    id: 'amc_details.my_refunds.status_pending',
  },
  statusComplementaryInfo: {
    id: 'amc_details.my_refunds.status_complementary_info',
  },
  statusComplementaryInfoPending: {
    id: 'amc_details.my_refunds.status_complementary_info_pending',
  },
  statusPec: {
    id: 'amc_details.my_refunds.status_pec',
  },
  statusSSuite: {
    id: 'amc_details.my_refunds.status_s_suite',
  },
  year: {
    id: 'suivi_sinistre.year',
  },
  motif: {
    id: 'amc_details.demandes.motif',
  },
  wireNotice: {
    id: 'refund.detail.wire.notice',
  },
  emptyState: {
    id: 'amc.refunds.empty.state',
  },
  downloadFileTitle: {
    id: 'amc.refunds.download.file.title',
  },
  completeCITitle: {
    id: 'amc.refunds.complete.ci.title',
  },
  wire: {
    id: 'amc.details.wire',
  },
  mandat: {
    id: 'amc.details.mandat',
  },
  V: {
    id: 'amc.details.wire',
  },
  M: {
    id: 'amc.details.mandat',
  },
  C: {
    id: 'amc.details.check',
  },
  nomMedcin: {
    id: 'medcin.ci',
  },
  adressMedcin: {
    id: 'adress.medcin.ci',
  },
  grantedFees: {
    id: 'grantedFees',
  },
  modalHeader: {
    id: 'complete.ci.refund.header.title',
  },
  send: {
    id: 'complete.ci.refund.send.button',
  },
  modalDescription: {
    id: 'complete.ci.refund.modal.description',
  },
});
